import React, { Component } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare, faMinusSquare, faCheckSquare, faSquare } from "@fortawesome/free-solid-svg-icons";

import CheckboxTree from 'react-checkbox-tree';
import '/node_modules/react-checkbox-tree/lib/react-checkbox-tree.css';


interface InfaMDMMigrationModalProps {
  show: boolean;
  error: string;
  message: string;
  infaMDMSaaSLoggedIn: boolean;
  infaMDMSaaSProj: any|null;
  infaMDMSaaSFolder: any|null;
  configs: any|null;
  handleClose: () => void;
  pullInfaSaaSFolderList: (projId: string) => void;
  handleTriggerInfaMDMSaaSMigration: (selProj: string, selFolder: string) => void;
  
  //handleAction: null | (data: any) => void;
  //handleSubmit: (data: any) => void | null;
}

interface InfaMDMMigrationModalState {
  selProject: string;
  selFolder: string;
  checked: string[];
  expanded: string[];
}

export default class InfaMDMMigrationModal extends Component<InfaMDMMigrationModalProps, InfaMDMMigrationModalState> {
  constructor(props: InfaMDMMigrationModalProps) {
    super(props);
    this.state = {
      selProject: '',
      selFolder: '',
      checked: [],
      expanded: ['srcSystem','lkpRS','sysRanks','dm'],
    };
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    
    switch (name) {
    case 'selProject':
      this.setState({ selProject: value });
      this.props.pullInfaSaaSFolderList(value);
      break;
    case 'selFolder':
      this.setState({ selFolder: value });
      break;
    default:
      console.warn(`Unhandled state key: ${name}`);
    }
   
  };

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    this.props.handleTriggerInfaMDMSaaSMigration(this.state.selProject, this.state.selFolder);
  };

  render() {
    const { show, message, error,  handleClose, infaMDMSaaSProj, infaMDMSaaSFolder, configs } = this.props;
    const { selProject, selFolder } = this.state;

    return (
      <Modal show={show} onHide={handleClose} size="lg" centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title>Infa MDM SaaS Migration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.handleSubmit}>
            {this.props.infaMDMSaaSLoggedIn &&
            <>
            <Form.Group controlId="formSelProject" className="mb-3 custom-select">
              <Form.Label>Project Name</Form.Label>
              <Form.Control as="select" name="selProject" 
                value={selProject}
                onChange={(e) => this.handleChange(e)} >
                <option>Select</option>
                {infaMDMSaaSProj && infaMDMSaaSProj.projs.map((o:any, idx:number) => (
                  <option value={o.id}>{o.name}</option>
                ))}	
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="formSelFolder" className="mb-3 custom-select">
              <Form.Label>Folder Name</Form.Label>
              <Form.Control as="select" name="selFolder" 
                value={selFolder}
                onChange={(e) => this.handleChange(e)} >
                <option>Select</option>
                {infaMDMSaaSFolder && infaMDMSaaSFolder.folders.map((o:any, idx:number) => (
                  <option value={o.id}>{o.name}</option>
                ))}	
              </Form.Control>
            </Form.Group>
            </>
            }
            
            <div className="my-3">
              <Form.Label>Migration Checklist</Form.Label>
              <div style={{maxHeight:'500px', overflowY: 'auto'}}>
                <CheckboxTree
                  nodes={this.props.configs}
                  checked={this.state.checked}
                  expanded={this.state.expanded}
                  onCheck={checked => this.setState({ checked })}
                  onExpand={expanded => this.setState({ expanded })}
                  icons={{
                    check: null,
                    uncheck: null,
                    halfCheck: <FontAwesomeIcon icon={faSquare} />, // Add a custom icon for half-checked if desired
                    expandClose: <FontAwesomeIcon icon={faPlusSquare} />,
                    expandOpen: <FontAwesomeIcon icon={faMinusSquare} />,
                    expandAll: <FontAwesomeIcon icon={faPlusSquare} />,
                    collapseAll: <FontAwesomeIcon icon={faMinusSquare} />,
                    parentClose: null,
                    parentOpen: null,
                    leaf: null,
                 }}
                />
              </div>
            </div>

            <Button variant="primary" type="submit" className="w-100">
              Submit
            </Button>
          </Form>
          
        </Modal.Body>
      </Modal>
    );
  }
}
